<template>
    <div class="intro-text">
        <!-- 标题 -->
        <h3 class="intro-text-title">{{ $t('explanation') }}</h3>

        <!-- 可折叠的容器 -->
        <div class="intro-text-content" :class="{ 'intro-text-content--collapsed': collapsed }">
            <p v-html="props.text" />
        </div>

        <!-- 折叠按钮 -->
        <div class="intro-text-collapse-btn" @click="collapsed = !collapsed">
            <span class="collapse-icon" :class="{ 'collapse-icon--expanded': !collapsed }">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2 8L6 4L10 8"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
        </div>
    </div>
</template>

<script >
import { ref } from 'vue-demi';
import { LanguageId, useI18n } from '../../common/useI18n';
const __sfc_main = {};
__sfc_main.props = {
  text: {
    type: String,
    default: ''
  },
  languageId: {
    type: Number,
    default: LanguageId.EN
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const $t = useI18n(props.languageId);
  const collapsed = ref(true);
  return {
    props,
    $t,
    collapsed
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.intro-text-title {
    margin-bottom: 0.1rem;
    font-size: 0.3rem;
    font-weight: 600;
    color: #000;
}

.intro-text-content {
    font-size: 0.22rem;
    line-height: 1.6;
    color: #666;
    overflow: hidden;
    transition: max-height 0.3s ease;

    // 折叠状态：限制最大高度
    &--collapsed {
        max-height: 4.8em; // 约 3 行文字
    }

    p {
        margin: 0;
        white-space: pre-line;
    }

    // 链接样式
    :deep(a) {
        color: #1890ff;
        text-decoration: underline;
        cursor: pointer;

        &:hover {
            color: #40a9ff;
        }
    }
}

.intro-text-collapse-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.16rem 0;
    cursor: pointer;

    .collapse-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        transition: transform 0.3s ease;
        width: 0.24rem;
        height: 0.24rem;

        svg {
            width: 100%;
            height: 100%;
        }

        // 展开状态：箭头向上
        &--expanded {
            transform: rotate(0deg);
        }

        // 折叠状态：箭头向下
        &:not(.collapse-icon--expanded) {
            transform: rotate(180deg);
        }
    }
}
</style>
